import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ContentDialogSuccessErrorEditRouteResponse, ContentType, StandardDialogData } from 'src/app/interfaces/mat.interface';
import { SuccessErrorEditedCustomRouteResponse } from 'src/app/pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.response';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './standard-dialog.html',
  styleUrls: ['./standard-dialog.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class StandardDialog {  
  public data: StandardDialogData = inject(MAT_DIALOG_DATA);  
  
  protected iconName = computed(() => {
    if (this.data.iconName) return this.data.iconName;
    
    if (this.isOnlyErrorList()) return 'error';
    
    return this.isSuccessList() ? 'warning' : undefined;
  })
  
  protected getContentString(): string | undefined {
    const content = this.data.content;
    if (!content) return undefined;
    
    return this._isStringContent(content) ? content : undefined;
  }
  
  protected getContentDialogSuccessErrorEditRouteResponse(): ContentDialogSuccessErrorEditRouteResponse | undefined {
    const content = this.data.content;
    if (!content) return undefined;
    
    return this._isContentDialogSuccessErrorEditRouteResponse(content) ? content : undefined;
  }
  
  protected isOnlyErrorList(): boolean {
    return !this.isSuccessList() && this.isErrorList();
  }
  
  protected isSuccessList(): boolean {
    const content = this.data.content as ContentDialogSuccessErrorEditRouteResponse;
    const successList = content ? content.successList : null;
    if (!successList) return false;
    
    return successList.length > 0;
  }
  
  protected isErrorList(): boolean {
    const content = this.data.content as ContentDialogSuccessErrorEditRouteResponse;
    const errorList = content ? content.errorList : null;
    if (!errorList) return false;

    return errorList.length > 0;
  }
  
  protected getTitleDialog(): string {
    const title = this.data.title;
    if (title) return title;
    
    return this.isOnlyErrorList() 
      ? 'No se ha podido modificar la ruta' 
      : 'Ruta modificada parcialmente';
  }
  
  protected getSuccessList(): SuccessErrorEditedCustomRouteResponse[] {
    const content = this.data.content as ContentDialogSuccessErrorEditRouteResponse;
    return content.successList || [];
  }
  
  protected getErrorList(): SuccessErrorEditedCustomRouteResponse[] {
    const content = this.data.content as ContentDialogSuccessErrorEditRouteResponse;
    return content.errorList || [];
  }
  
  // Type guards
  private _isStringContent(content: ContentType| undefined): content is string {
    return typeof content === 'string';
  }

  private _isContentDialogSuccessErrorEditRouteResponse(content: ContentType | undefined): content is ContentDialogSuccessErrorEditRouteResponse {
    return typeof content === 'object' && content !== null && ('errorList' in content || 'successList' in content);
  }
}
